<template>
  <div id="ManagementPanel" :class="{ active: view, close: !view }">
    <div class="mdl-grid">
      <div class="mdl-cell mdl-cell--1-col mdl-cell--12-col-tablet mdl-cell--12-col-phone">
        <span class="material-icons closePanel" @click="closePanel()">close</span>
      </div>
      <div class="mdl-cell mdl-cell--11-col mdl-cell--12-col-tablet mdl-cell--12-col-phone">
        <h3>{{ $t('users.titleSearchUser') }}</h3>
        <p class="subTitle">{{ $t('users.subTitleSearchUser') }}</p>

        <div class="space"></div>
        <div class="mdl-cell mdl-cell--12-col">
          <div class="contentInputFilter">
            <div class="contentIcon"><span class="material-icons">search</span></div>
            <div class="contentInput"><input type="text" :placeholder="$t('users.searchUsers')" @keyup="searchByString"
                v-model="searchString" /></div>
          </div>
        </div>
        <div class="mdl-cell mdl-cell--12-col contentUsersSearch">
          <div v-for="(user, index) in dataFilter" :key="index" class="singleUser"
            :class="['user-' + index, { view: getView(user.id), disabled: isPreExisting(user.id) }]" @click="setUser(index, user.id)"
            :id="['user-' + user.id]">
            <div class="userTexts">
              <div class="nameUser">{{ user.last_name }} {{ user.first_name }}</div>
              <div class="emailUser">{{ user.email }}</div>
            </div>
            <div class="material-icons">done</div>
          </div>
        </div>
        <br /><br /><br />
        <div class="contentButton">
          <button class="cdlButtonGreen" @click="confirmUser()">
            {{ $t('users.confirmUser') }}
          </button>
        </div>
        <br /><br />
        <p class="cancel" @click="closePanel()">{{ $t('users.cancel') }}</p>

      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/ManagementPanel.scss"
import { useUserStore } from '@/stores/UserStore'

export default {
  name: 'SearchUser',
  props: {
    view: {
      type: Boolean,
      required: true,
    },
    allUsers: {
      type: Object,
      required: true
    },
    singleGroup: {
      type: Object,
      required: true
    },
    ctrlPanelUsersSearch: {
      type: Object,
      required: true
    },
    ctrlPanelUsersSearchFromGroup: {
      type: Object,
      required: true
    },
    usersGroup: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      usersSelected: [],
      dataFilter: [],
      searchString: '',
      hideIds: [],
      partialUsers: [],
      preExistingIds: [],
      he: {
          Accept: "application/json",
          Authorization: "Bearer " + this.$keycloak.idToken,
        }
    }
  },
  methods: {
    isPreExisting(id) {
      return !!(this.singleGroup && this.singleGroup.id && this.preExistingIds.includes(id));
    },
    applyPreselection() {
      try {
        if (!this.singleGroup.id && Array.isArray(this.usersGroup) && this.usersGroup.length > 0) {
          this.usersGroup.forEach((u) => {
            const el = document.getElementById("user-" + u.id);
            if (el) {
              el.classList.add('active');
            }
            // Ensure usersSelected contains the user object
            if (!this.usersSelected.find(sel => sel.id === u.id)) {
              // Try to find the full user object from the available lists
              const full = (this.allUsers || []).find(x => x.id === u.id) || u;
              this.usersSelected.push(full);
            }
          });
        }
      } catch (e) {
        // no-op safeguard
      }
    },
    closePanel() {
      // Do not emit confirm with empty selection; just close the side panel flow safely
      this.$emit('close-panel', { whichPanel: 1 });
    },
    setUser(index, id) {
      // Prevent toggling for already-in-role users (add-only behavior)
      if (this.isPreExisting(id)) return;

      const el = document.getElementById("user-" + id);
      if (!el) return;

      if (el.classList.contains('active')) {
        el.classList.remove('active');
        const idx = this.usersSelected.findIndex(u => u.id === id);
        if (idx > -1) {
          this.usersSelected.splice(idx, 1);
        }
      } else {
        el.classList.add('active');
        // Ensure we add the correct user object, regardless of filtering
        const full = (this.allUsers || []).find(x => x.id === id)
          || (this.dataFilter || [])[index]
          || { id };
        if (!this.usersSelected.some(u => u.id === id)) {
          this.usersSelected.push(full);
        }
      }
    },
    confirmUser() {
      // Emit only newly added users (exclude pre-existing role members)
      const newUsers = (this.usersSelected || []).filter(u => !this.isPreExisting(u.id));
      this.$emit('confirm-user-group', { users: newUsers })
      if (this.ctrlPanelUsersSearch) {
        this.usersSelected = [];
        let allInputs = document.getElementsByClassName("singleUser");
        for (let i = 0; i < allInputs.length; i++) {
          allInputs[i].classList.remove('active');
        }
      }
    },
    searchByString() {

      if (this.searchString.length == 0) {
        this.buildList();
        return;
      }

      this.hideAll();

      this.partialUsers.forEach(elm => {
        if (
          elm.first_name.toLowerCase().includes(this.searchString.toLowerCase()) ||
          elm.last_name.toLowerCase().includes(this.searchString.toLowerCase()) ||
          elm.email.toLowerCase().includes(this.searchString.toLowerCase()) ||
          (elm.phone && elm.phone.toLowerCase().includes(this.searchString.toLowerCase()))
        ) {
          document.getElementById("user-" + elm.id).classList.add('view');
        }
      });

      this.hidePartials();
    },
    hideAll() {
      let allInputs = document.getElementsByClassName("singleUser");
      for (let i = 0; i < allInputs.length; i++) {
        allInputs[i].classList.remove('view');
      }
    },
    viewAll() {
      let allInputs = document.getElementsByClassName("singleUser");
      for (let i = 0; i < allInputs.length; i++) {
        allInputs[i].classList.add('view');
      }
    },
    hidePartials() {
      for (let i = 0; i < this.hideIds.length; i++) {
        document.getElementById("user-" + this.hideIds[i]).classList.remove('view');
      }
    },
    getView(id) {
      return !this.hideIds.find((element) => element == id);
    },
    buildList() {
      let userStore = useUserStore();
      // Reset disabled/pre-existing ids each time we rebuild
      this.preExistingIds = [];
      if( this.singleGroup.id ) {
        this.partialUsers = this.dataFilter;
        this.hideIds = [];
        let url = "users/v2/role/" + this.singleGroup.id + "/users?page_number=1&disable_pagination=true";
        this.axios
          .get(
            window.VUE_APP_MISTRA_URL + url,
            { headers: this.he }
          )
          .then((response) => {
            // Reset selection to reflect current role membership
            this.usersSelected = [];
            const current = Array.isArray(response.data.items) ? response.data.items : [];
            // Track pre-existing members to disable them
            this.preExistingIds = current.map(u => u.id);
            // Preselect current members
            current.forEach((u) => {
              const el = document.getElementById("user-" + u.id);
              if (el) {
                el.classList.add('active');
              }
              const full = (this.dataFilter || []).find(x => x.id === u.id) || u;
              if (!this.usersSelected.find(sel => sel.id === full.id)) {
                this.usersSelected.push(full);
              }
            });
            // Hide the logged-in user from selection if present
            this.dataFilter.forEach((elm) => {
              if ( elm.email == userStore.user.email ) {
                this.hideIds.push(elm.id);
              }
            });
          })
          .catch(function (err) {
            console.log(err);
          });
      }
      else {
        // Tolgo dalla lista me stesso.
        this.dataFilter.forEach((elm) => {
              if ( elm.email == userStore.user.email ) {
                this.hideIds.push(elm.id);
              }
          });
      }


      this.viewAll();
      setTimeout(() => {
        this.hidePartials();
      }, 500);
    },
    updatePanel() {
      this.dataFilter = this.allUsers;
      this.hideIds = [];
      this.viewAll();
      this.buildList();
      // Preselect already chosen users when creating a new role (no role id yet)
      this.$nextTick(() => {
        this.applyPreselection();
      });
    }
  },
  watch: {
    ctrlPanelUsersSearch: {
      handler(newValue) {
        if (newValue) {
          this.updatePanel();
        }
      },
      deep: true
    },
    ctrlPanelUsersSearchFromGroup: {
      handler(newValue) {
        if (newValue) {
          this.updatePanel();
        }
      },
      deep: true
    },
    singleGroup: {
      handler() {
        let allInputs = document.getElementsByClassName("singleUser");
        for (let i = 0; i < allInputs.length; i++) {
          allInputs[i].classList.remove('active');
        }
        this.updatePanel();
      },
      deep: true
    }
  },
  mounted() {
    this.dataFilter = this.allUsers;
    this.buildList();
    this.$nextTick(() => {
      this.applyPreselection();
    });
  }
}
</script>
<style scoped>
.contentUsersSearch .singleUser.disabled {
  pointer-events: none;
  opacity: 0.6;
  cursor: default;
}
.contentUsersSearch .singleUser.disabled .material-icons {
  opacity: 0.3;
}
</style>
